import React, { useState } from 'react';
import { getImageSrc } from '../../../util';
import { MarketingAPIQueuePushRequest } from '../../../interfaces/marketing';
import { marketingAPI } from '../../../api/marketing';

type Props = {
  className?: string;
  style?: React.CSSProperties;
  header?: string;
  description?: string;
  parentHeader?: string;
};

const CTACard: React.FC<Props> = ({
  className,
  style,
  header = "Let's get started.",
  parentHeader = 'Ready to join?',
  description = 'Process your first TableTab order in under 72 hours.',
}) => {
  const [inputEmail, setInputEmail] = useState('');
  return (
    <div className={`${className} bg-gray-100`} style={style}>
      <div className="relative max-w-7xl">
        <div className="bg-gradient-to-r from-primary-600 to-primary-600 rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
          <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
            <div className="lg:self-center">
              <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
                <span className="block">{parentHeader}</span>
                <span className="block text-red-900">{header}</span>
              </h2>
              <p className="mt-4 text-lg leading-6 text-orange-50">
                {description}
              </p>
              <form
                className="mt-5 sm:flex sm:items-center"
                id={'cta_card_form'}
                onSubmit={async e => {
                  e.preventDefault();
                  // @ts-ignore
                  window.analytics.identify({
                    email: inputEmail,
                  });
                  const pushToQ: MarketingAPIQueuePushRequest = {
                    email: inputEmail,
                  };
                  const response = await marketingAPI.pushEmailToQueue(pushToQ);
                  window.open(
                    'https://portal.tabletab.io/signup?ref=cta_card_form',
                  );
                }}
              >
                <div className="max-w-xs w-full">
                  <label htmlFor="email" className="sr-only">
                    Email
                  </label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    onChange={e => {
                      setInputEmail(e.target.value);
                    }}
                    className="shadow-sm focus:ring-gray-900 focus:border-gray-900 block w-full text-base border-gray-300 rounded-full"
                    placeholder="Enter your email"
                  />
                </div>
                <button
                  type="submit"
                  className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-base font-medium rounded-full text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 sm:mt-0 sm:ml-3 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-2/5 "
                >
                  Get Started
                </button>
              </form>
            </div>
          </div>
          <div className="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
            <picture className="lazyload transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20">
              <source
                srcSet={getImageSrc('home_cta_card_v2.webp')}
                type={'image/webp'}
              />
              <source
                srcSet={getImageSrc('home_cta_card_v2.png')}
                type={'image/png'}
              />
              <img
                className="lazyload transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                width={'800'}
                height={'400'}
                data-src={getImageSrc('home_cta_card_v2.png')}
                alt="App screenshot"
              />
            </picture>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTACard;
